import { Routes, Route, Navigate } from "react-router-dom";
import StatusPage from "./pages/StatusPage";
import { AdminAuthGuard } from "./components/AdminAuthGuard";
import { LoginPage } from "./pages/admin/Login";
import { DashboardPage } from "./pages/admin/Dashboard";
import { ServicesPage } from "./pages/admin/Services";
import { IncidentsPage } from "./pages/admin/Incidents";
import { MaintenancePage } from "./pages/admin/Maintenance";
import NotFoundPage from "./pages/NotFound";

export default function App() {
  return (
    <Routes>
      {/* Public status page */}
      <Route path="/:tenant" element={<StatusPage />} />

      {/* Admin login */}
      <Route path="/:tenant/admin/login" element={<LoginPage />} />

      {/* Admin dashboard */}
      <Route
        path="/:tenant/admin"
        element={
          <AdminAuthGuard>
            <DashboardPage />
          </AdminAuthGuard>
        }
      />
      <Route
        path="/:tenant/admin/services"
        element={
          <AdminAuthGuard>
            <ServicesPage />
          </AdminAuthGuard>
        }
      />
      <Route
        path="/:tenant/admin/incidents"
        element={
          <AdminAuthGuard>
            <IncidentsPage />
          </AdminAuthGuard>
        }
      />
      <Route
        path="/:tenant/admin/maintenance"
        element={
          <AdminAuthGuard>
            <MaintenancePage />
          </AdminAuthGuard>
        }
      />

      {/* Unknown tenant-route fallback */}
      <Route path="/:tenant/*" element={<NotFoundPage />} />

      {/* Root redirect */}
      <Route path="/" element={<Navigate to="/demo" replace />} />

      {/* Global 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
